import { LoadingView } from "@app/components/Loading";
import CandidateListTable, { CandidateListMode } from "@pages/candidate/list/CandidateListTable";
import { DVTJCUVAcquireCddParentTabIds } from "@pages/dvtjcuv/common/AcquireCddTabs";
import DVTJCUVPipelineTableList, { DVTJCUVPipelineListMode } from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import SearchCddConditionInput from "@pages/dvtjcuv/rundvtjcuv/search/SearchCddConditionInput";
import { React, useEffect, useState } from 'react';


const InitSearchConditions = {
    'search_by_cdd_list': {},
    'search_by_dvtjcuv_pipeline': {},
    'search_by_range': {},
}

const SearchCddManager = (props) => {
    const [pipeLineList, setPipeLineList] = useState([]);
    const [candidates, setCandidates] = useState([]);
    const [selectRow, setSelectRow] = useState(null);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showBtnSearchByPipeline, setShowBtnSearchByPipeline] = useState(true);
    const [showBtnSearchByRange, setShowBtnSearchByRange] = useState(true);
    
    const [totalCount, setTotalCount] = useState(0);

    const [isLoading, setLoading] = useState(false);

    const searchParams = new URLSearchParams(props.location.search)
    const parentTabId = searchParams.get("parentTabId")
    const tabId = searchParams.get("tabId")
    const mode = searchParams.get("mode")

    const onShowEditItem = (item, fromReferee) => {
        item.fromReferee = !!fromReferee
        setSelectRow({...item})
        setShowUpdateModal(true)
    }

    useEffect(() => {
        if (parentTabId === DVTJCUVAcquireCddParentTabIds.PRE_EMAIL_TAB
            || parentTabId === DVTJCUVAcquireCddParentTabIds.EMAIL_TAB) {
            setShowBtnSearchByPipeline(false)
            setShowBtnSearchByRange(false)
       }
    }, [parentTabId]);

    return (
        <>
            <div className="card card-default">
                <div className="card-header">
                    <h3 className="card-title text-bold">
                        {mode === 'search-receiver' ? 'Search Cdd Receiver' : 'Search Cdd'} ({totalCount})
                    </h3>
                    <div className="card-tools w-100 mr-0">
                        <SearchCddConditionInput
                            noPaging
                            notShowBtnSearchByPipelines={!showBtnSearchByPipeline}
                            notShowBtnSearchByRanges={!showBtnSearchByRange}
                            parentTabId={parentTabId}
                            tabId={tabId}
                            mode={mode}
                            onSearching={() => {
                                setLoading(true)
                            }}
                            onSearchCddRecResult={(cddrecs, total) => {
                                setLoading(false)
                                setCandidates(cddrecs)
                                setTotalCount(total)
                            }}
                            onSearchPipelineResult={(pipelines, total) => {
                                setLoading(false)
                                // alert('Search result: ' + pipelines.length + ' items found')
                                // remove duplicate receiver_cdd_id and only keep item has service_use_times is max
                                // TODO: CHECK LATER.
                                // const uniquePipelines = pipelines.reduce((acc, curr) => {
                                //     const existing = acc.find(p => p.receiver_cdd_id === curr.receiver_cdd_id);
                                //     if (existing) {
                                //         return acc.map(p => p.receiver_cdd_id === curr.receiver_cdd_id ? {
                                //             ...p,
                                //             service_use_times: Math.max(p.service_use_times, curr.service_use_times)
                                //         } : p)
                                //     }
                                //     return [...acc, curr]
                                    
                                // }, [])
                                
                                // Group pipelines by cdd_id or receiver_cdd_id
                                const map = {};
                                pipelines.forEach((p) => {
                                    p.cdd_receiver_id = p.cdd_receiver
                                    if (mode === 'search-receiver' && !map[p.cdd_receiver_id]) {
                                        map[p.cdd_receiver_id] = p;
                                    }
                                    if (mode === 'search-cdd' && !map[p.cdd_id]) {
                                        map[p.cdd_id] = p;
                                    }
                                    // else if (mode !== 'search-receiver' && !map[p.cdd_id]) {
                                    //     map[p.cdd_id] = p;
                                    // }
                                });
                                const uniquePipelines = Object.values(map);
                                setPipeLineList(uniquePipelines)
                                setTotalCount(uniquePipelines.length)
                            }}/>
                    </div>
                </div>
                <div className="card-body">
                    
                    {showBtnSearchByPipeline &&
                    <DVTJCUVPipelineTableList pipeLines={pipeLineList}
                                              hideColumns={[]}
                                              mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_CDD}
                                              cddIsReceiver={mode === 'search-receiver'}
                                              parentTabId={parentTabId}
                                              onEditItem={(selectItem, fromReferee) => onShowEditItem(selectItem, fromReferee)}
                                              onClose={(reload) => {}}
                    />
                    }

                    {!showBtnSearchByPipeline &&
                    <CandidateListTable candidates={candidates}
                                        // allCandidateIds={allCandidateIds}
                                        noPagination
                                        mode={CandidateListMode.DVTJCUV_SEARCH_CDD}
                                        showBtnSearchByRange={false}
                                        totalCount={totalCount}
                    />
                    }
                </div>
            </div>

            {/*<UpdateDVTJCUVPipelineModal isShow={showUpdateModal}*/}
            {/*                            pipeLineInfo={selectRow}*/}
            {/*                            onClose={(reload) => onCloseUpdatePipeLine(reload)}*/}
            {/*/>*/}

            {isLoading &&
                <LoadingView />
            }

        </>
    )
}

export default SearchCddManager;
